import React from 'react'
import Module from '../lib/Module'

type LoadedModule = {
  i: number;
  j: number;
  module: Module;
}

type DeviceProps = {
  deviceRef: React.RefObject<HTMLDivElement>;
  deviceModules: LoadedModule[];
}

class DeviceGrid extends React.Component<DeviceProps> {
  render(): JSX.Element {
    const { deviceRef } = this.props
    return (
      <div style={{ marginTop: '3.5rem', height: '100%', width: '100%' }}>
        <div
          style={{
            height: '90vh',
            width: '95%',
            boxShadow: '0 0 12px 0 hsla(0, 0%, 0%, 0.2)',
          }}
          ref={deviceRef}
        />
      </div>
    )
  }
}

export default DeviceGrid
